"use client";
import { cn } from "@/lib/utils";
import { useCallback, useEffect, useState } from "react";
import { useHeader } from "@/hooks/headerContext";
import SeeMoreButton from "@/components/views/list/see-more/SeeMoreButton";

export default function SeeMore() {
  const [classes, setClasses] = useState("");
  const { dataCount } = useHeader();
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleScrollIndex = () => {
    const scrollPosition = window.scrollY;

    if (
      scrollPosition === 0 ||
      (scrollPosition >= 2 * window.innerHeight && currentIndex > 0)
    ) {
      setCurrentIndex((prevIndex) => prevIndex - 1);
    }
  };

  const handleScroll = useCallback(() => {
    const scrollPosition = window.scrollY;
    const newClass = scrollPosition >= 850 ? "hidden opacity-0" : "flex";

    if (classes !== newClass) {
      setClasses(newClass);
    }
  }, [classes]);

  useEffect(() => {
    handleScroll();
    handleScrollIndex();

    window.addEventListener(
      "scroll",
      () => {
        handleScroll();
        handleScrollIndex();
      },
      { passive: true },
    );

    return () => {
      window.removeEventListener("scroll", () => {
        handleScroll();
        handleScrollIndex();
      });
    };
  }, [handleScroll]);

  const handleClick = useCallback(() => {
    const venueCards = document.querySelectorAll("#venue-card");
    
    if (venueCards.length === 0) return;
  
    const currentScrollY = window.scrollY;
  
    if (currentScrollY < 222) {
      const firstCard = venueCards[0] as HTMLElement;
      window.scrollTo({
        top: firstCard.offsetTop - 90,
        behavior: 'smooth'
      });
      setCurrentIndex(0);
      return;
    }
  
    const nextIndex = currentIndex + 1;
    
    if (nextIndex < venueCards.length) {
      const nextCard = venueCards[nextIndex] as HTMLElement;
      
      window.scrollTo({
        top: nextCard?.offsetTop,
        behavior: 'smooth'
      });
      
      setCurrentIndex(nextIndex);
    }
  }, [currentIndex]);

  if (!dataCount?.venues || dataCount?.venues === 0 || dataCount?.venues < 3)
    return <></>;

  return (
    <div className={cn("items-center flex-col justify-center", classes)}>
      <div
        className={cn(
          "fixed md:hidden z-40 duration-200 bottom-[100px] p-2 rounded-3xl bg-primary/20 justify-center items-center",
          classes,
        )}
      >
        <SeeMoreButton onClick={handleClick} count={dataCount?.venues} />
      </div>
    </div>
  );
}
